import { ArrowRightIcon } from '@heroicons/react/24/outline';
import DealCard from './Card';
import { LoaderIcon } from '../../utils/svg';
import useNavigation from '../../hook/useNavigation';
import { buildSafeLink, isEmptyData } from '../../utils/helper';

const Deal = (props) => {
	const { data, isLoading } = props;

  const navigate = useNavigation();

	const handleClick = () => {
		navigate.push(buildSafeLink(`/promotion?section_id=${data?.id}`));
	};

	return (
		<div className={`w-full h-fuil p-4 ${isEmptyData(data?.outlets) && 'hidden'}`}>
			{isLoading ? (
				<div className='w-full flex justify-center items-center'>
					<LoaderIcon />
				</div>
			) : (
				<>
					<div className='flex justify-between items-center mb-2' onClick={handleClick}>
						<div className='text-gray-700 font-semibold text-sm'>{data?.name}</div>
						<ArrowRightIcon className='h-5 w-5 text-gray-700' />
					</div>
					<div className='w-full overflow-x-auto overflow-y-hidden scrollbar-hide'>
						<div className='flex w-max h-full gap-4'>
							{data?.outlets?.slice(0, 5)?.map((item, index) => (
								<div key={index} className='shrink-0'>
									<DealCard {...{ item }} />
								</div>
							))}
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default Deal;
